"use strict";

(function () {
  var debounce = function debounce(fn, delay) {
    var timeout;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return fn.apply(void 0, args);
      }, delay);
    };
  };
  var getGap = function getGap(wrapper) {
    var _getComputedStyle;
    return parseInt((_getComputedStyle = getComputedStyle(wrapper)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.gap) || 0;
  };
  var getCumulativeHeight = function getCumulativeHeight(sections, index) {
    var totalHeight = 0;
    for (var i = 0; i < index; i++) {
      totalHeight += sections[i].scrollHeight;
    }
    return totalHeight;
  };
  var equalizeHeights = function equalizeHeights(sections) {
    var maxHeight = 0;
    sections.forEach(function (item) {
      item.style.height = 'auto'; // Reset the height before recalculating
      maxHeight = Math.max(maxHeight, item.scrollHeight);
    });
    sections.forEach(function (item) {
      return item.style.height = "".concat(maxHeight, "px");
    });
  };
  var getOffset = function getOffset(el, container) {
    return container ? container.offsetTop + el.offsetTop : el.offsetTop;
  };
  document.querySelectorAll('.scrolling_features').forEach(function (feature) {
    var sections = feature.querySelectorAll('.scrolling_features_section');
    var wrapper = feature.querySelector('.scrolling_features_wrapper');
    var bgContainer = feature.closest('.background_container');
    var tabContainer = feature.closest('.tab_container');
    var getHeaderHeight = function getHeaderHeight() {
      var _feature$querySelecto;
      return ((_feature$querySelecto = feature.querySelector('.main_text_header')) === null || _feature$querySelecto === void 0 ? void 0 : _feature$querySelecto.scrollHeight) || 0;
    };
    var isSticky = function isSticky() {
      sections.forEach(function (el, index) {
        var prevEl = sections[index - 1] || null;
        if (!prevEl) return;
        var elRect = el.getBoundingClientRect();
        var topOffset = parseInt(getComputedStyle(el).top, 10) || 0; // get top position calculated from CSS
        var paddingBottom = parseInt(getComputedStyle(el).paddingBottom, 10) || 0; // get paddingBottom from CSS
        var offset = paddingBottom * 2; // extra offset for start title animation

        // check if slide became sticky at the top of screen with extra offset
        var isNextSticky = elRect.top <= topOffset + offset;

        // if next slide became sticky, set previous element is-sticky
        prevEl === null || prevEl === void 0 || prevEl.classList.toggle('is-sticky', isNextSticky);
      });
    };
    sections.forEach(function (el, index) {
      var scrollTitle = el.querySelector('.top-title');
      scrollTitle === null || scrollTitle === void 0 || scrollTitle.addEventListener('click', function () {
        return window.scrollTo({
          top: getOffset(feature, bgContainer || tabContainer) + getHeaderHeight() - getGap(wrapper) + getCumulativeHeight(sections, index),
          behavior: 'smooth'
        });
      });
    });
    var initFeature = function initFeature() {
      isSticky();
      equalizeHeights(sections); // Call the function on window load and resize to ensure the height is recalculated
    };

    // Вызываем при загрузке и изменении размеров окна
    window.addEventListener('scroll', isSticky, {
      passive: true
    });
    window.addEventListener('resize', debounce(initFeature, 100), {
      passive: true
    });
    document.addEventListener("DOMContentLoaded", initFeature);
    document.addEventListener('readystatechange', function (e) {
      return e.target.readyState === 'complete' && initFeature();
    });
  });
})();